export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ocV3WBeEd7LgfDra6igomR/M_-_1.webp'

/**
 * Early resource hints. This module is imported first in index.tsx so it runs
 * before React mounts.
 *
 * The hero mockup is the LCP element. In a client-rendered app the browser only
 * discovers it once React has downloaded, parsed and rendered the Hero — several
 * seconds into the load on a throttled mobile connection. Preloading it here
 * starts the download immediately, in parallel with the React bundle.
 */
;(function earlyHints() {
  if (typeof document === 'undefined') return
  if (document.getElementById('hero-preload')) return

  const origins: Array<[string, boolean]> = [
    ['https://cdn.magicpatterns.com', true],
    ['https://fonts.googleapis.com', false],
    ['https://fonts.gstatic.com', true],
  ]
  for (const [href, crossorigin] of origins) {
    const link = document.createElement('link')
    link.rel = 'preconnect'
    link.href = href
    if (crossorigin) link.crossOrigin = 'anonymous'
    document.head.appendChild(link)
  }

  const preload = document.createElement('link')
  preload.id = 'hero-preload'
  preload.rel = 'preload'
  preload.as = 'image'
  preload.href = HERO_IMAGE
  preload.setAttribute('fetchpriority', 'high')
  document.head.appendChild(preload)

  // The webfont stylesheet is only discovered once index.css is parsed. Kicking
  // the request off here fetches it in parallel instead, so the fonts are ready
  // sooner and the text paints as early as possible.
  const fontCss = document.createElement('link')
  fontCss.rel = 'preload'
  fontCss.as = 'style'
  fontCss.href =
    'https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700&family=Oswald:wght@400;500;600;700&display=block'
  document.head.appendChild(fontCss)
})()
